import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import queryRequestStatusRole from 'api/ShareObject/queryRequestStatus';
import { ShareObjectStatus } from 'types/Share';
import { FormatDate } from 'components/dates/FormatDate';

export default function useRequestStatusRole() {
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState<ShareObjectStatus>(
        ShareObjectStatus.Draft,
    );
    const [role, setRole] = useState<string>('');
    const [created, setCreated] = useState<string>('');
    const [reason, setReason] = useState<string>('');

    const [error, setError] = useState<boolean>(false);
    const params = useParams();

    useEffect(() => {
        if (client) {
            setLoading(true);
            if (params.uri) {
                client
                    .query(queryRequestStatusRole(params.uri))
                    .then((response) => {
                        if (!response.errors) {
                            setRole(
                                response.data.getShareObject
                                    .userRoleForShareObject,
                            );
                            setStatus(response.data.getShareObject.status);
                            setCreated(
                                FormatDate(
                                    response.data.getShareObject.created,
                                ),
                            );
                            setReason(response.data.getShareObject.reason);
                        } else {
                            setError(true);
                        }
                        setLoading(false);
                    });
            }
        }
    }, [client, params.uri, setError]);
    return { status, role, created, reason, loading, error };
}
